import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { ActiveEQuery } from '../../models/active-e-query';
import { EQueryAttachmentsDownloader } from '../../../../e-queries/e-query-details/e-query-attachments-downloader';

@Component({
    selector: 'active-e-query-attachments',
    template: require('./active-e-query-attachments.component.html'),
    styles: [require('./active-e-query-attachments.component.scss')],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ActiveEQueryAttachmentsComponent {
    @Input()
    public activeEQuery: ActiveEQuery;

    constructor(
        private readonly eQueryAttachmentsDownloader: EQueryAttachmentsDownloader,
    ) { }

    public downloadAttachment(attachmentId: number): Promise<boolean> {
        return this.eQueryAttachmentsDownloader.downloadInvestigatorAttachment(attachmentId, this.activeEQuery.eQueryId);
    }

    public previewAttachment(attachmentId: number): Promise<boolean> {
        return this.eQueryAttachmentsDownloader.previewInvestigatorAttachment(attachmentId, this.activeEQuery.eQueryId);
    }
}
